import React, { useContext, useState } from "react";
import { AiOutlinePoweroff, AiOutlineMenu, AiOutlineDown } from "react-icons/ai";
import { useNavigate } from "react-router";
import { logoutApi } from "../../redux/login/loginApiCalls";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { State } from "../../redux/store";
import { useTranslation } from "react-i18next";
import { clearUserApi } from "../../redux/users/UserApiCalls";
import { clearRoleApi } from "../../redux/roles/roleApiCalls";
import { clearPaymentModeApi } from "../../redux/paymentMode/paymentModeApiCalls";
import { clearExpenseApi } from "../../redux/expense/expenseApiCalls";
import { clearPermissionApi } from "../../redux/permissions/permissionApiCalls";
import { clearScientificDayApi } from "../../redux/scientificday/scientificDayApiCalls";
import { clearAdsInfoApi } from "../../redux/adsinfo/adsInfoApiCalls";
import { clearAssurancesApi } from "../../redux/assurances/assuranceApiCalls";
import { clearCabinetApi } from "../../redux/cabinets/cabinetApiCalls";
import { clearDiplomApi } from "../../redux/diploms/diplomApiCalls";
import { clearDoctorApi } from "../../redux/doctors/doctorApiCalls";
import { clearMedecinTypeApi } from "../../redux/medecinType/medecinTypeApiCalls";
import { clearPartnersApi } from "../../redux/partners/partnerApiCalls";
import { clearPaymentApi } from "../../redux/payments/paymentApiCalls";
import { clearRegFormApi } from "../../redux/regForm/regFormApiCalls";
import MyLink from "../frontend/sidebar/MyLinks";
import MyLinkWithSearch from "../frontend/sidebar/MyLinkWithSearch";
import { ShowFrontEndContext } from "../frontend/types";
import { pageDirContext } from "../../App";

interface HeaderInterface {
  toggleOffcanvas?: any;
}

const Header: React.FC<HeaderInterface> = ({ toggleOffcanvas }) => {
  const { userData } = useSelector((state: State) => state.login);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const { pageDir, setPageDir } = useContext(pageDirContext)

  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  const handleLogout = async () => {
    try {
      await dispatch(logoutApi);
      await dispatch(clearScientificDayApi);
      await dispatch(clearAdsInfoApi);
      await dispatch(clearAssurancesApi);
      await dispatch(clearCabinetApi);
      await dispatch(clearDiplomApi);
      await dispatch(clearDoctorApi);
      await dispatch(clearExpenseApi);
      await dispatch(clearMedecinTypeApi);
      await dispatch(clearPartnersApi);
      await dispatch(clearPaymentModeApi);
      await dispatch(clearPaymentApi);
      await dispatch(clearPermissionApi);
      await dispatch(clearRegFormApi);
      await dispatch(clearRoleApi);
      await dispatch(clearUserApi);
      localStorage.removeItem("timeOut");
      localStorage.removeItem("StoreType");

      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const { t, i18n } = useTranslation();

  const { HomePageRef } = useContext(ShowFrontEndContext);

  const ToggleHomePage = () => {
    if (userData?.username) {
      navigate("/");
    }
    if (!userData._id) {
      if (HomePageRef?.current) {
        HomePageRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

    const [showDropdownMenu, setShowDropdownMenu] = useState(false)
    
    const changeLanguage = (lng: string) => {
      i18n.changeLanguage(lng)
      localStorage.setItem("lang", lng)
      setShowDropdownMenu(false)
      if (lng === "ar") {
        document.body.dir = "rtl";
        localStorage.setItem("dir", "rtl");
        setPageDir("rtl")
      } else {
        document.body.dir = "ltr";
        localStorage.setItem("dir", "ltr");
        setPageDir("ltr")
      }
      document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    }

  const [isHidden, setIsHidden] = useState<boolean>(true)

  return (
    <header className="bg-main p-4 mx-auto flex justify-between items-center fixed w-full z-20 transition-all duration-300 shadow-md">
      {/* Left section */}
      <div className="flex items-center space-x-4">
        {/* Mobile menu toggle button */}
        <button
          className="md:hidden text-white text-3xl"
          onClick={() => {
            setShowMobileMenu(!showMobileMenu)
            setIsHidden(false)
          }}
          aria-label="Toggle menu"
        >
          <AiOutlineMenu />
        </button>

        {/* Home button (visible only on desktop) */}
        <button
          className={`bg-[#FFF] text-main hover:bg-main hover:text-[#FFF] border-2 border-[#FFF] font-bold py-2 px-4 rounded transition-all duration-300 hidden md:block`}
          onClick={ToggleHomePage}
          aria-label="Navigate to home page"
        >
          {userData?.username
            ? userData?.username
            : userData?.fullName ?? t("Page d'accueil")}
        </button>
      </div>

      {/* Links section for larger screens */}
      {!userData?.username && 
        <div className="hidden md:flex flex-1 justify-center">
          <MyLinkWithSearch />
        </div>
      }
      <div className="sm:flex md:hidden justify-center mt-4">
        <p className="text-2xl font-bold text-white text-center uppercase tracking-wide">
          {t("ONMDM")}
        </p>
      </div>


      {/* Right section with dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowDropdownMenu(!showDropdownMenu)}
          className="flex items-center bg-white text-main border-2 border-main font-bold py-2 px-3 rounded-full cursor-pointer transition duration-300 transform hover:scale-110"
        >
          <span>{t("options")}</span>
          <AiOutlineDown className="ml-2" />
        </button>

        {showDropdownMenu && (
          <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-300 shadow-lg rounded-lg py-2 z-50">
            {/* Language Selection */}
            <p
              onClick={() => changeLanguage("fr")}
              className="block px-4 py-2 text-gray-700 hover:bg-gray-200 cursor-pointer"
            >
              🇫🇷 Français
            </p>
            <p
              onClick={() => changeLanguage("ar")}
              className="block px-4 py-2 text-gray-700 hover:bg-gray-200 cursor-pointer"
            >
              🇸🇦 العربية
            </p>

            <hr className="my-2" />

            {/* Login / Logout Button */}
            {userData?.username || userData?.fullName ? (
              <div
                onClick={handleLogout}
                className="flex items-center px-4 py-2 text-red-600 font-bold cursor-pointer hover:bg-gray-200"
              >
                <AiOutlinePoweroff className="mr-2 text-xl" />
                {t("Logout")}
              </div>
            ) : (
              <div
                onClick={() => navigate("/login")}
                className="flex items-center px-4 py-2 text-main font-bold cursor-pointer hover:bg-gray-200"
              >
                <img className="w-6 h-6 mr-2" src="/assets/images/key.png" alt="Login" />
                {t("Login")}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Mobile Menu */}
      {showMobileMenu && !userData?.username && (
        <div
          className={`${isHidden ? 'hidden' : 'block'} absolute top-24 ${
            pageDir === "rtl" ? "left-0" : "right-0"
          } w-full bg-white shadow-lg p-4 rounded-md z-30 transition-transform transform md:hidden`}
        >
          <MyLink setIsHidden={() => setIsHidden(!isHidden)} />
        </div>
      )}
    </header>
  );
};

export default Header;
